export const applyPagination = (rows, page, pageSize = 20) => {
  if (page === null) {
    return rows;
  }

  const paginated = rows.slice(page * pageSize, page * pageSize + pageSize);

  return paginated.length ? paginated : rows;
};
